<cx-import-order-entries
  *ngIf="shouldDisplayImport$ | async"
></cx-import-order-entries>
<cx-export-order-entries
  *ngIf="shouldDisplayExport$ | async"
></cx-export-order-entries>
